import { Component } from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import BCard from '../../../framework/component/container/BCard';

import CourseCompleted from './CourseCompleted';

import 'bootstrap/dist/css/bootstrap.min.css';

import './QuizStart.css';
import apiClient from "../../../framework/web/ApiClient";

interface ServerMessage {
    code: string;
    message: string;
}

interface Quiz {
    name: string;
    quizCode: string;
    timeLimit: number;
    passingScore: number;
    numberOfQuestions: number;
}

interface State {
    quiz: Quiz | null;
    loading: boolean;
    error: string | null;
    serverMessage: ServerMessage[] | null;
}

const PAGE_TITLE = "AMS - Test";

class QuizStart extends Component<{}, State> {

    constructor(props: {}) {
        super(props);
        this.state = {
            quiz: null,
            loading: true,
            error: null,
            serverMessage: null,
        };
    }

    componentDidMount() {
        document.title = PAGE_TITLE;

        let curQuizId = this.#getQuizId();

        if (curQuizId) {
            this.fetchQuiz(curQuizId);
        }
    }

    fetchQuiz = async (curQuizId: string) => {
        const headers = {
            'Access-Control-Allow-Origin': '*',
            "Content-Type": "application/json"
        };
        apiClient.get('/ams/api/v1/researcher-trainings/quizzes/' + curQuizId, { withCredentials: true, headers })
            .then(response => {
                if (response.status != 204) {
                    if (response.data.errors) {
                        this.setState({ quiz: response.data.data, serverMessage: response.data.errors, loading: false })
                    } else {
                        this.setState({ quiz: response.data.data, loading: false });
                    }
                }
            }).catch(error => {
                this.setState({ error: 'Error fetching questions', loading: false });
            });
    };

    #getQuizId(): string {
        let queryParams = new URLSearchParams(window.location.search);
        let quizId = queryParams.get('quizId');
        return quizId || '';
    };

    #getQuizName(): string {
        let queryParams = new URLSearchParams(window.location.search);
        let quizName = queryParams.get('quiz-name');
        return quizName || '';
    };

    #getRequiredNumberOfQuestions(quiz: Quiz | null): string {
        if (!quiz) {
            return '';
        }

        return `${quiz?.numberOfQuestions * (quiz?.passingScore / 100)}/${quiz?.numberOfQuestions}`;
    }

    render() {
        const quizId = this.#getQuizId();
        const { quiz, loading, error, serverMessage } = this.state;

        if (loading) {
            return <div>Loading...</div>;
        }

        if (error) {
            return <div>{error}</div>;
        }

        if (serverMessage && serverMessage[0] && "032001" === serverMessage[0].code) {
            return <CourseCompleted courseName={quiz?.name ?? ''} message={serverMessage[0].message} />
        }

        return (
            <BCard title={quiz?.name ?? ''}
                contentPanel={<>
                    You need to score {this.#getRequiredNumberOfQuestions(quiz)} ({quiz?.passingScore}%) to pass the test. Your AMS profile will be updated when you pass.
                    <br /><br />
                    You have {quiz?.timeLimit} minutes to complete this test.
                    <br /><br />
                    Once you start, you cannot pause the timer. If you close the tab your answers will not be submitted, and you will be required to start the test again.
                </>}
                bottomPanel={
                    <Link to={`/quiz/${quizId}?page=quiz`}>
                        <Button variant="primary">Start {quiz?.name} Test</Button>
                    </Link>}
            />
        )
    };
}

export default QuizStart;
